import { http } from "../services/http";
import type { SystemHealthResponse } from "../types/systemHealth";

export interface SystemStatus {
  JsBundleHash: string;
  BuildVersion: string;
  // The first discovery host, for older clients that read only one.
  IPApi: string;
  // Probed in order; null when discovery is off.
  IPApis: string[] | null;
  DiscoverIPPorts: number[] | null;
  MobileSaml: boolean;
  DisableLocalUserLogin: boolean;
}

// Unauthenticated.
export function getSystemStatus(options: { signal?: AbortSignal } = {}): Promise<SystemStatus> {
  return http.get<SystemStatus>("/system_status", options);
}

// Every check the admin portal reports on, tiered and sorted by the server.
export function getAdminHealth(options: { signal?: AbortSignal } = {}): Promise<SystemHealthResponse> {
  return http.get<SystemHealthResponse>("/admin/health", options);
}
